<template>
  <PerkContainer icon="financing-dark-medium" is-raw-clickable :is-klarna="true" @value-info-click="openOverlay">
    <KlarnaView
      class="klarna-perks"
      :price="selectedPrice"
      :is-product-perks-enabled="true"
      :is-klarna-custom-modal-close-focus-enabled="isKlarnaCustomModalCloseFocusEnabled"
    />
  </PerkContainer>
</template>
<script setup>
import KlarnaView from '@nuxt-common/media-card-large/app/modules/credit-finance/components/KlarnaView';
import PerkContainer from '~/modules/productPerks/components/PerkContainer';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import once from '~/utils/once';
import { klarnaDetailsClicked } from '~/features/analytics/productPerks';

const selectedPrice = useProductPrice();
const { killswitches } = useKillswitches();

const fireAnalytics = once(klarnaDetailsClicked);

const { isKlarnaCustomModalCloseFocusEnabled } = killswitches;

const openOverlay = () => {
  const klarnaContainer = document.querySelector('.klarna-container .align-center-middle');
  const klarna = klarnaContainer.childNodes?.[1] || klarnaContainer;

  if (klarna) {
    const { shadowRoot } = klarna;

    if (shadowRoot) {
      const button = shadowRoot.querySelector('button');
      if (button) {
        fireAnalytics();
        button.click();
      }
    }
  }
};
</script>
<style lang="scss" brand="mcom">
@import '~settingSCSS';
.klarna-perks {
  ::part(osm-container) {
    background-color: $background-color;
  }
}
</style>

<style lang="scss" brand="bcom">
.klarna-perks {
  ::part(osm-container) {
    background-color: transparent;
  }
}
</style>

<style lang="scss">
@import '~settingSCSS';
.klarna-perks {
  ::part(osm-container) {
    @include body(large);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-clamp: 3;
  }
  ::part(osm-cta) {
    display: none;
  }

  &.klarna-container {
    min-height: auto;
  }
}
</style>
